(function () {
  const tocNav = document.getElementById('toc-nav');
  const content = document.getElementById('product-content');

  if (!tocNav || !content) return;

  // 掃描所有 h2 生成目錄
  const headings = content.querySelectorAll('h2.content-block__heading');

  if (headings.length === 0) {
    document.getElementById('product-toc')?.style.setProperty('display', 'none');
    return;
  }

  headings.forEach((h2, i) => {
    // 確保有 id 錨點
    if (!h2.closest('section')?.id) {
      h2.closest('section').id = 'block-' + (i + 1);
    }
    const sectionId = h2.closest('section').id;

    const link = document.createElement('a');
    link.href = '#' + sectionId;
    link.textContent = h2.textContent;
    tocNav.appendChild(link);
  });

  // Intersection Observer：高亮當前區塊
  const sections = content.querySelectorAll('.content-block');
  const links = tocNav.querySelectorAll('a');

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const id = entry.target.id;
          links.forEach((link) => {
            link.classList.toggle(
              'is-active',
              link.getAttribute('href') === '#' + id
            );
          });
        }
      });
    },
    { rootMargin: '-20% 0px -70% 0px', threshold: 0 }
  );

  sections.forEach((section) => observer.observe(section));
})();
